import { render, staticRenderFns } from "./africaOriginalExcel.vue?vue&type=template&id=fb415072&scoped=true&"
import script from "./africaOriginalExcel.vue?vue&type=script&lang=js&"
export * from "./africaOriginalExcel.vue?vue&type=script&lang=js&"
import style0 from "./africaOriginalExcel.vue?vue&type=style&index=0&id=fb415072&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb415072",
  null
  
)

export default component.exports